export default {
  title: "Staff notifications",
  description: "Operational alerts that require staff attention.",
  empty: {
    title: "No notifications",
    description: "There are no notifications matching your filters.",
    openOnly: "No open notifications right now.",
  },
  filters: {
    status: "Status",
    severity: "Severity",
    category: "Category",
    any: "Any",
  },
  statusTabs: {
    open: "Open",
    acknowledged: "Acknowledged",
    resolved: "Resolved",
    all: "All",
  },
  status: {
    open: "Open",
    acknowledged: "Acknowledged",
    resolved: "Resolved",
  },
  severity: {
    warning: "Warning",
    error: "Error",
    critical: "Critical",
  },
  category: {
    payment: "Payment",
    booking: "Booking",
    receipt: "Receipt",
    scheduler: "Scheduler",
    integration: "Integration",
    support: "Support",
    device: "Device",
    unknown: "Other ({{value}})",
  },
  titles: {
    refund: {
      failed: "Refund failed at provider",
      rejected_handshake_failed: "Handshake rejection refund failed",
      retry_exhausted: "Refund retry exhausted — manual intervention required",
    },
    device: {
      low_battery: "Low battery: {{displayLabel}} ({{batteryLevel}}%)",
      low_battery_kiosk: "Low battery: Tablet {{kioskName}}",
      low_battery_kiosk_at_house: "Low battery: Tablet {{kioskName}} in {{houseName}}",
      low_battery_reader: "Low battery: POS reader",
      low_battery_reader_at_house:
        "Low battery: POS reader in {{houseName}}, linked to kiosk {{kioskName}}",
      low_battery_reader_linked: "Low battery: POS reader linked to kiosk {{kioskName}}",
      low_battery_reader_at_house_only: "Low battery: POS reader in {{houseName}}",
    },
    booking: {
      created: "{{activityName}} — {{customerName}}",
      receipt: {
        manual_amount_registered: "Partner registered manual receipt amount",
      },
    },
    handshake: {
      notification_exhausted: "Handshake open notifications failed",
      message_blocked: "Handshake message blocked",
    },
    support: {
      ticket: {
        created: "New support ticket ({{ticketNumber}})",
        partner_message: "Partner reply on ticket {{ticketNumber}}",
        notification_failed: "Support ticket notification failed ({{ticketNumber}})",
      },
    },
    customer_support: {
      chat: {
        message: "Customer support chat message",
      },
    },
    test: {
      receipt: {
        warning: "[dev] Test receipt warning",
      },
      refund: {
        failed: "[dev] Refund failed at provider",
      },
      manual: "Test alert",
    },
  },
  eventTypes: {
    refund: {
      failed: "Refund failed",
      rejected_handshake_failed: "Handshake rejection refund failed",
      retry_exhausted: "Refund retry exhausted",
    },
    device: {
      low_battery: "Low battery",
    },
    booking: {
      created: "New booking created",
      receipt: {
        manual_amount_registered: "Manual receipt amount registered",
      },
    },
    handshake: {
      notification_exhausted: "Handshake notifications failed",
      message_blocked: "Handshake message blocked",
    },
    support: {
      ticket: {
        created: "New support ticket",
        partner_message: "Partner ticket reply",
        notification_failed: "Support ticket notification failed",
      },
    },
    customer_support: {
      chat: {
        message: "Customer support chat message",
      },
    },
    test: {
      receipt: {
        warning: "Test receipt warning",
      },
      refund: {
        failed: "Test refund failure",
      },
      manual: "Test manual notification",
    },
  },
  targetTypes: {
    booking: "Booking",
    external_payment: "External payment",
    handshake_session: "Handshake session",
    support_ticket: "Support ticket",
    customer_support_chat: "Customer support chat",
    device: "Device",
    reader: "Reader",
  },
  details: {
    eventType: "Event",
    serialNumber: "Serial number",
    target: "Target",
    lastOccurred: "Last occurred",
  },
  occurrences: "{{count}} occurrences",
  groups: {
    today: "Today",
    yesterday: "Yesterday",
    older: "Earlier",
  },
  audit: {
    acknowledged: "Acknowledged by {{admin}} on {{date}}",
    resolved: "Resolved by {{admin}} on {{date}}",
    unknownAdmin: "Unknown staff",
  },
  card: {
    expand: "Expand notification: {{title}}",
    collapse: "Collapse notification: {{title}}",
  },
  bulk: {
    selectAll: "Select all on this page",
    selectOne: "Select {{title}}",
    selected: "{{count}} selected",
    pageCount: "{{count}} on this page",
    hint: "Select multiple, then acknowledge or resolve together",
    clearSelection: "Clear selection",
    acknowledge: "Acknowledge",
    resolve: "Resolve",
    acknowledgeSuccess: "{{count}} notifications acknowledged",
    resolveSuccess: "{{count}} notifications resolved",
    partialError: "{{count}} actions failed",
  },
  actions: {
    openPayment: "Open payment",
    openBooking: "Open booking",
    openHandshake: "Open handshake",
    openTicket: "Open ticket",
    openChat: "Open chat",
    openDevice: "Go to device",
    openStructure: "Go to structure",
    noLinks: "No linked resource",
    acknowledge: "Acknowledge",
    resolve: "Resolve",
    reopen: "Reopen",
    acknowledgeSuccess: "Notification acknowledged",
    resolveSuccess: "Notification resolved",
    reopenSuccess: "Notification reopened",
    acknowledgeError: "Failed to acknowledge",
    resolveError: "Failed to resolve",
    reopenError: "Failed to reopen",
  },
  pagination: "Page {{page}} of {{totalPages}} ({{total}} total)",
  paginationSingle_one: "{{count}} notification",
  paginationSingle_other: "{{count}} notifications",
} as const;
